<template>
  <div class="chnl-select-wrap">
    <el-dropdown trigger="click" :disabled="disabled">
      <div class="show-wrap" :style="{ width: width }" :class="{ 'disabled-wrap': disabled }">
        <div class="text-wrap" v-if="value && value.length > 0">
          {{ value.map((item) => item.channel).join("、") }}
        </div>
        <div v-else class="text-wrap placeholder-text">请选择</div>
        <i class="down-icon el-icon-arrow-down"></i>
      </div>
      <el-dropdown-menu class="drop-wrap" slot="dropdown">
        <div class="option-wrap">
          <div class="option-item" v-for="item of optionList" :key="item.channel">
            <span class="check-label">{{ item.channel }}</span>
            <div class="check-list">
              <el-checkbox
                class="check-item second"
                v-model="item.secondary"
                @change="(value) => changeSelect(value, 'primary', item)"
              ></el-checkbox>
              <el-checkbox
                class="check-item main"
                v-model="item.primary"
                @change="(value) => changeSelect(value, 'secondary', item)"
              ></el-checkbox>
            </div>
          </div>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { getChnl } from "@/api/popuManage.js";
export default {
  name: "ChannelSelect",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    width: {
      type: String,
      default: "200px",
    },
    option: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // optionList: [
      //   { channel: "FB", primary: false, secondary: false },
      //   { channel: "GG", primary: false, secondary: false },
      //   { channel: "TT", primary: false, secondary: false },
      //   { channel: "unity", primary: false, secondary: false },
      //   { channel: "mintegral", primary: false, secondary: false },
      //   { channel: "今日头条", primary: false, secondary: false },
      //   { channel: "微信", primary: false, secondary: false },
      //   { channel: "广点通", primary: false, secondary: false },
      //   { channel: "快手", primary: false, secondary: false },
      // ],
      optionList: [],
      checked: false,
    };
  },
  mounted() {
    this.initSelectData();
  },
  methods: {
    searchChnlList(cb) {
      getChnl().then((res) => {
        if (res.code === "0000") {
          this.optionList = res.data.map((item) => {
            return {
              channel: item.channel,
              primary: false,
              secondary: false,
            };
          });
          if (cb) {
            cb.call(this);
          }
        }
      });
    },
    initSelectData() {
      if (this.optionList.length > 0) {
        this.setStatus();
      } else if (this.option.length > 0) {
        this.optionList = this.option;
        this.setStatus();
      } else {
        this.searchChnlList(() => {
          this.setStatus();
        });
      }
    },
    setStatus() {
      this.optionList.forEach((item) => {
        item.primary = false;
        item.secondary = false;
      });
      if (this.value) {
        this.value.forEach((item) => {
          let optionItem = this.optionList.find((op) => op.channel === item.channel) || {};
          optionItem.primary = item.primary;
          optionItem.secondary = item.secondary;
        });
      }
    },
    changeSelect(value, type, data) {
      if (value) {
        data[type] = false;
      }
      this.updateValue();
    },
    updateValue() {
      let copyData = JSON.parse(JSON.stringify(this.optionList));
      this.$emit(
        "input",
        copyData.filter((item) => item.primary || item.secondary)
      );
    },
  },
  watch: {
    value() {
      this.initSelectData();
    },
    option(opt) {
      console.log("opt变化了");
      console.log(opt);
    },
  },
};
</script>

<style lang="less" scoped>
.chnl-select-wrap {
  .show-wrap {
    display: flex;
    align-items: center;
    height: 32px;
    border: 1px solid #dcdfe6;
    border-radius: 2px;
    padding: 0 6px;
    background-color: #fff;
    .text-wrap {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
      margin-right: 4px;
      padding-left: 6px;
      &.placeholder-text {
        color: #bbb;
      }
    }
    .down-icon {
      flex-shrink: 0;
    }
  }
  .disabled-wrap {
    background: #f5f7fa;
  }
}
.drop-wrap {
  .option-wrap {
    width: 140px;
    box-sizing: border-box;
    .option-item {
      display: flex;
      align-items: center;
      padding: 4px 12px;
      &:hover {
        background-color: #eee;
      }
      .check-label {
        color: rgba(0, 0, 0, 0.85);
        font-size: 14px;
        width: 60px;
      }
      .check-list {
        .check-item {
          margin-right: 0px;
          margin-left: 10px;
          &.second {
            /deep/ .el-checkbox__inner {
              border: 1px solid #999;
            }
            /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
            /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
              background-color: #999;
            }
          }
          &.main {
            /deep/ .el-checkbox__inner {
              border: 1px solid rgba(74, 217, 148, 1);
            }
            /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
            /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
              background-color: rgba(74, 217, 148, 1);
            }
          }
        }
      }
    }
  }
}
</style>
